<div class="progress-container">
  <mat-progress-bar mode="determinate" value="50"></mat-progress-bar>
</div>

<div id="select-users">
  <div class="title-container">
    <p>{{ "select_user.title" | translate }}</p>
  </div>
  <div class="title-container">
    @if (flux === 'spa') {
      <p  class="disclaimer">
      {{ "select_user.spa_disclaimer" | translate }}
      </p>
    }
  </div>

  <ul class="cards">
    @for (el of profiles; track $index) {
      <li
        class="card user"
        [ngClass]="
          el.selectable && isAvailableUsers(el)
            ? el.selected
              ? 'selected'
              : 'selectable'
            : 'disabled'
        "
        (click)="profileSelected(el)"
      >
        <div class="wrap-name">
          <div class="user-name">{{ el.inizialiNome }}</div>
          <h3 class="card-title">{{ el.displayName.toLocaleLowerCase() }}</h3>
        </div>
        <label class="form-control-checkbox">
          @if (el.selected) {
            <input type="checkbox" checked />
          } @else {
            <input type="checkbox" />
          }
          <span class="checkmark"></span>
        </label>
      </li>
    }

  </ul>

  <div class="btn-container">
    <button
      class="my-button"
      (click)="goTo('summary')"
      [disabled]="!isComplete"
    >
      {{ "select_user.button_proceed" | translate }}
    </button>
  </div>
</div>
